export default __webpack_public_path__ + "static/media/Major Rune Stone of the Exile.91f9b283.jpg";